<div class="main-logout-container delete-ui">
    <div>
        <h2 class="delete-header">Choose Poster Options</h2>
        <hr>
        <p class="logout-subtitle">
            {{ data.cusMail ? "Select your preferred theme (Dark or Light) and send email." : "Select your preferred theme (Dark or Light) and download the poster." }}
          </p>
          <mat-radio-group aria-label="Select an option" class="radio-button" (change)="radioSelected($event)">
            <mat-radio-button [value]=true [checked]="isDarkMode">Dark theme</mat-radio-button>
            <mat-radio-button [value]=false>Light theme</mat-radio-button>
           </mat-radio-group>
           <!-- loading spinner -->
           <div class="spinner-container">
            <span class="spinner" *ngIf="userFeedback.loading"></span>
          </div>
          <div class="poster">
              <img class="poster" [src]="poster" *ngIf="!userFeedback.loading">
          </div>
        <div class="logout-button-div">
            <button class="logout-cancel-button equal-width-button" mat-flat-button color="accent"
                (click)="close()">Cancel</button>
            <button mat-flat-button class="logout-button equal-width-button" color="primary" *ngIf="!isBtnLoad" (click)="data.cusMail == true ? sendPoster() : downloadPoster() ">{{data.cusMail == true ?"Send" : "Download"}}</button>
            <button class="logout-button equal-width-button" mat-flat-button *ngIf="isBtnLoad" color="primary">
            <mat-icon class="button-load" svgIcon="loader"></mat-icon>
            </button>
        </div>
    </div>
</div>

